import type { CoverSheetConfigCard } from '../../types';

export const addAdditionalContactCard = {
  id: 'additionalContacts.addAdditionalContacts',
  outerTitle:
    'Add additional contacts (Appraiser, Attorney, Home Warranty, etc)',
  fields: {
    newContact: {
      name: 'newContact',
      type: 'buttonSelect',
      action: {
        name: 'toggleHiddenCard',
      },
      label: 'Add New Contact',
      options: [
        {
          label: 'Attorney',
          value: 'additionalContacts.attorney',
        },
        {
          label: 'Appraiser',
          value: 'additionalContacts.appraiser',
        },
        {
          label: 'Home Warranty',
          value: 'additionalContacts.homeWarranty',
        },
        {
          label: 'Other',
          value: 'additionalContacts.other',
        },
      ],
    },
  },
} satisfies CoverSheetConfigCard;
